import { Locale, MembershipPlan, gql } from '@yi/core';

import { MEMBERSHIP_PATHNAME } from '../routes';

const { MONTH } = gql.typesClient.MembershipPlanInterval;
const { Free, Premium, Digital } = gql.typesClient.MembershipTier;

export const getSignupUrl = (locale: Locale, membership: MembershipPlan): string => {
  if (!membership) return '';
  const { tier, interval } = membership;
  const localizedSegment = locale === 'es' ? '/es' : '';
  const localizedSuffix = locale === 'es' ? '-es' : '';

  switch (tier) {
    case Free:
      return `${localizedSegment}${MEMBERSHIP_PATHNAME}`;
    case Digital:
      return interval === MONTH
        ? `${localizedSegment}/create-account/default-${locale}`
        : `${localizedSegment}/create-account/annual${localizedSuffix}`;
    case Premium:
      return `${localizedSegment}/create-account/premium${localizedSuffix}`;
    default: {
      return '';
    }
  }
};
